// export const hostNameAndPort = "http://localhost:80";
export const hostNameAndPort = "https://testapi.followonelabs.com";
// export const hostNameAndPort = "https://api.followone.com";
